import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, withHistory } from "@openimis/fe-core";
import PolicyHolderEnrollmentBatchSearcher from "../../components/PolicyHolderEnrollmentBatchSearcher";

const styles = (theme) => ({
  page: theme.page,
});

class PolicyHolderEnrollmentBatchHomePage extends Component {
  onDoubleClick = (enrollment) => {
    if (this.props.history && enrollment?.uuid) {
      this.props.history.push(
        `/enrollment/policyholder-batch/${enrollment.uuid}/detail`
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <PolicyHolderEnrollmentBatchSearcher
          cacheFiltersKey="enrollmentPolicyHolderBatchPageFiltersCache"
          onDoubleClick={this.onDoubleClick}
        />
      </div>
    );
  }
}

export default injectIntl(
  withModulesManager(
    withHistory(
      withTheme(withStyles(styles)(PolicyHolderEnrollmentBatchHomePage))
    )
  )
);
